<mat-nav-list fxLayout="column" *ngIf="isAuthenticated" fxFlex>
  <!-- Root List Items -->
  <ng-container *ngIf="headerLoggedInSettings && currentNavList === NavLists.profile; then profileNavList"></ng-container>
  <ng-container *ngIf="headerLoggedInSettings && currentNavList === NavLists.claims; then claimsNavList"></ng-container>
  <ng-container *ngIf="headerLoggedInSettings && currentNavList === NavLists.coverage; then coverageNavList"></ng-container>
  <ng-container *ngIf="headerLoggedInSettings && currentNavList === NavLists.root">
    <ng-container *ngFor="let item of headerLoggedInSettings">
      <!-- Regular Menu Items -->
      <ng-container *ngIf="item.LinkUrl !== 'action_profile' && !item.LinkUrl.endsWith('action_claims_support') && !item.LinkUrl.endsWith('action_coverage'); else profileBlock">
        <a
          mat-list-item
          *ngIf="this.checkRouteAvailability(item.LinkUrl)"
          [routerLink]="item.LinkUrl"
          [gtmClick]="item.Caption"
          [gtmLinkURL]="item.LinkUrl"
          (click)="sidenavRef.toggle()"
          routerLinkActive="active">
          {{ item.Caption }}
        </a>
        <mat-divider></mat-divider>
      </ng-container>
      <!-- Profile Menu Item -->
      <ng-template #profileBlock>
        <ng-container *ngIf="item.LinkUrl === 'action_profile'; else claimsBlock">
          <ng-container *ngIf="chooseLanguage">
            <a [title]="chooseLanguageTitle" class="language-toggle" href="javascript:void(0);" (click)="toggleLanguage()" [gtmClick]="chooseLanguage">{{
              chooseLanguage
            }}</a>
          </ng-container>
          <span fxFlex></span>
          <mat-divider></mat-divider>
          <a
            mat-list-item
            routerLinkActive="active"
            (click)="currentNavList = NavLists.profile"
            style="
              height: 120px;
              background-image: url(/assets/images/profile-bubble.svg);
              background-repeat: no-repeat;
              background-color: #f0f6fc;
            ">
            <div class="avatar-container" fxFlex fxLayoutAlign="center center">
              <span style="margin-right: 6px"><pgh-avatar name="{{ fullName }}" color="{{ userAvatarColor }}" size="30"></pgh-avatar></span>
              <!--<span class="circle">

                <img [src]="userAvatarUrl || './assets/images/avatars/desktop.png'"
                  alt="generic avatar" /></span>-->
              <!-- <mat-icon class="primary-account-icon" svgIcon="primary-account"></mat-icon> -->
              <span>{{ userGivenName }}</span>
              <span fxFlex></span>
              <mat-divider [vertical]="true" style="position: static; height: 80px"></mat-divider>
              <mat-icon>chevron_right</mat-icon>
            </div>
          </a>
        </ng-container>
      </ng-template>
      <ng-template #claimsBlock>
        <ng-container *ngIf="item.LinkUrl === 'action_claims_support'; else coverageBlock">
        <a
          mat-list-item
          routerLinkActive="active"
          href="javascript:void(0);"
          (click)="currentNavList = NavLists.claims"
          [gtmClick]="item.Caption">
          {{ item.Caption }}
        </a>
        <mat-divider></mat-divider>
        </ng-container>
      </ng-template>

      <ng-template #coverageBlock>
        <ng-container>
           <a
          mat-list-item
          routerLinkActive="active"
          href="javascript:void(0);"
          (click)="currentNavList = NavLists.coverage"
          [gtmClick]="item.Caption">
          {{ item.Caption }}
        </a>
        <mat-divider></mat-divider>
        </ng-container>
      </ng-template>



    </ng-container>
  </ng-container>
  <!-- Profile List Items -->
  <ng-template #profileNavList>
    <ng-container *ngIf="filteredProfileLinks?.length && profileLinksLoaded">
      <a mat-list-item class="link-primary-dark" (click)="currentNavList = NavLists.root">
        <adp-label labelKey="Global_Header_BackToMainMenu"></adp-label>
      </a>
      <a
        mat-list-item
        *ngFor="let childItem of filteredProfileLinks"
        [gtmClick]="childItem.Caption"
        (click)="this.profileButtonClick(childItem)">
        {{ childItem.Caption }}
        <mat-divider></mat-divider>
      </a>
    </ng-container>
  </ng-template>
  <ng-template #claimsNavList>
    <ng-container *ngIf="defaultClaimsLinks?.length">
      <a mat-list-item class="link-primary-dark" (click)="currentNavList = NavLists.root">
        <adp-label labelKey="Global_Header_BackToMainMenu"></adp-label>
      </a>
      <a
        mat-list-item
        *ngFor="let childItem of defaultClaimsLinks"
        [gtmClick]="childItem.Caption"
        (click)="this.claimsButtonClick(childItem)">
        {{ childItem.Caption }}
        <mat-divider></mat-divider>
      </a>
    </ng-container>
  </ng-template>
  <ng-template #coverageNavList>
    <ng-container *ngIf="defaultCoverageLinks?.length && defaultCoverageLinksLoaded">
      <a mat-list-item class="link-primary-dark" (click)="currentNavList = NavLists.root">
        <adp-label labelKey="Global_Header_BackToMainMenu"></adp-label>
      </a>
      <a
        mat-list-item
        *ngFor="let childItem of defaultCoverageLinks"
        [gtmClick]="childItem.Caption"
        (click)="this.coverageButtonClick(childItem)">
        {{ childItem.Caption }}
        <mat-divider></mat-divider>
      </a>
    </ng-container>
  </ng-template>
</mat-nav-list>
